"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement("svg", {
    width: "140",
    height: "16",
    viewBox: "0 0 140 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react2.default.createElement("path", {
    d: "M0 15.5563V0.351562H11.3304V3.86034H4.67993V6.78432H10.5914V10.1761H4.67993V15.5563H0Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M16.5039 15.5563V0.351562H21.307V15.6732L16.5039 15.5563Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M27.2188 15.5563V0.351562H30.9134L37.0712 8.30479H37.1944V0.351562H41.628V15.6732H37.9333L31.6524 7.60304H31.5292V15.6732L27.2188 15.5563Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M47.6602 15.5563V0.351562H55.5421C58.8674 0.351562 60.7147 1.75507 60.7147 4.09426C60.7147 5.84865 59.36 7.1352 57.5126 7.36912V7.48608C59.7295 7.48608 61.4536 9.12351 61.4536 11.1118C61.4536 13.8019 59.2368 15.5563 55.7885 15.5563H47.6602ZM52.3401 6.43344H54.1874C55.419 6.43344 56.1579 5.84865 56.1579 4.91297C56.1579 3.9773 55.419 3.3925 54.1874 3.3925H52.2169V6.43344H52.3401ZM54.3106 12.5153C55.7885 12.5153 56.6506 11.9305 56.6506 10.7609C56.6506 9.7083 55.7885 9.00655 54.4337 9.00655H52.4632V12.5153H54.3106Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M71.1857 9.59111C71.1857 11.2285 72.0478 12.0473 73.5256 12.0473C75.0035 12.0473 75.8656 11.1116 75.8656 9.59111V0.234375H80.6687V10.059C80.6687 13.5677 77.8361 15.79 73.6488 15.79C69.4615 15.79 66.6289 13.5677 66.6289 10.059V0.234375H71.432L71.1857 9.59111Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M91.2601 15.5563H86.457V0.351562H93.6001C97.9105 0.351562 100.127 2.22291 100.127 5.49777C100.127 7.36912 99.1421 9.00655 97.5411 9.82526L100.62 15.5563H95.3243L92.738 10.4101H91.2601V15.5563ZM91.2601 7.48608H93.2306C94.5853 7.48608 95.3243 6.66736 95.3243 5.61473C95.3243 4.44514 94.4622 3.74338 93.2306 3.74338H91.2601V7.48608Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M109.363 11.1111C109.486 12.0468 110.595 12.5146 111.826 12.5146C113.181 12.5146 114.043 11.9298 114.043 11.2281C114.043 10.5263 113.427 10.2924 111.703 9.94153L109.61 9.59066C106.654 9.12282 105.053 7.48539 105.053 5.02925C105.053 1.98831 107.885 0 111.703 0C116.014 0 118.354 1.87135 118.477 4.79533H114.166C114.166 3.85966 113.181 3.27486 111.826 3.27486C110.595 3.27486 109.856 3.7427 109.856 4.56141C109.856 5.26317 110.472 5.61404 112.073 5.96492L114.29 6.3158C117.368 6.78364 118.846 8.18715 118.846 10.7602C118.846 13.9181 116.014 15.9065 111.826 15.9065C107.639 15.9065 104.93 14.1521 104.93 11.1111H109.363Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M133.255 12.5151H128.329L127.467 15.556H122.664L127.96 0.234375H133.871L139.167 15.556H134.118L133.255 12.5151ZM129.191 9.3572H132.393L130.916 3.86011H130.792L129.191 9.3572Z",
    fill: "#1A1A1A"
  }), _react2.default.createElement("path", {
    d: "M71.1857 9.59111C71.1857 11.2285 72.0478 12.0473 73.5256 12.0473C75.0035 12.0473 75.8656 11.1116 75.8656 9.59111V0.234375H80.6687V10.059C80.6687 13.5677 77.8361 15.79 73.6488 15.79C69.4615 15.79 66.6289 13.5677 66.6289 10.059V0.234375H71.432L71.1857 9.59111Z",
    fill: "#1A1A1A"
  }));
};